import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';

import { ModulesManagerService } from '../../classes/Module/modules-manager.service';
import { Ask } from '../../classes/Ask/ask.service';
import { ContactSelectorPage } from '../../Modales/ContactSelector/contact-selector/contact-selector.page';
import { UserContact } from '../../classes/Contact/user-contact';
import { Share } from '../../classes/Share/share';
import { LoggerService } from '../../utils/logger.service';

@Component({
  selector: 'app-shares',
  templateUrl: './shares.component.html',
  styleUrls: ['./shares.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SharesComponent {
  private currentAsk: Ask
  public shareEmail: string = "";
  public deployed = false
  public pandingRequest = false
  @ViewChild("confirmsharedelete") confirmsharedelete;
  @Input()
  get CurrentAsk() {
    return this.currentAsk
  }

  set CurrentAsk(value) {
    this.currentAsk = value
    this.deployed = false
  }

  constructor(public manager: ModulesManagerService, private actionSheetCtrl: ActionSheetController) { }

  get CanAddShare() {
    return this.manager.Ws.availableFeatures() && !this.pandingRequest && this.shareEmail.trim().includes("@") && (this.manager.Usr.isLoged || this.manager.hasInternalKey(this.currentAsk.InternalKey))
  }

  get Shares() {
    return this.currentAsk?.Shares || []
  }

  get Contacts() {
    return this.manager.Usr.Contacts.filter(contact => {
      return this.currentAsk?.OwnerDisplayEmail != contact.Email && this.currentAsk?.TargetDisplayEmail != contact.Email && this.currentAsk?.Shares.find(share => share.Email == contact.Email) == null
    })
  }

  async addContact(event = null) {
    if (event) {
      event.preventDefault()
    }
    if (!this.manager.Ws.availableFeatures() || this.pandingRequest || !this.shareEmail.trim().includes("@")) {
      return
    }
    this.pandingRequest = true
    await this.manager.Ws.Send("Shares", "create", {
      AskId: this.currentAsk.Id,
      Email: this.shareEmail
    }, true).catch(err => LoggerService.error('Erreur lors de l\'ajout du partage', err))
    this.shareEmail = ""
    this.pandingRequest = false

  }

  private async confirmContact(Contact) {
    this.confirmsharedelete.presentAlert({
      header: this.manager.Trad.Parse('STR_DELETE'),
      message: this.manager.Trad.Parse('STR_SHARE_DELETE_CONFIRM'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: async () => {
            if (!this.manager.Ws.availableFeatures()) return;
            let resu = await this.manager.Ws.Send("Shares", "delete", { Id: Contact.Id, AskId: this.currentAsk.Id }, true)
            if (resu.error)
              this.manager.Tool.notify(this.manager.Trad.Parse(resu.error))
          },
          cssClass: 'delete-button',
        },
        {
          text: this.manager.Trad.Parse('STR_CANCEL'),
        },
      ],
    })
  }

  public async presentContactActionSheet(Contact: Share) {
    let contact: UserContact = null
    if (this.manager.Usr.isLoged)
      contact = this.manager.Usr.Contacts.find(contact => contact.Email == Contact.Email)
    //<ion-icon name="medal-outline"></ion-icon>

    let buttons = [
    ]

    if ((this.CurrentAsk?.isTarget || this.CurrentAsk?.isOldTarget) && this.currentAsk.GmaoRef < 1) {
      if (this.CurrentAsk?.isTarget)
        buttons?.push({
          text: this.manager.Trad.Parse('STR_TRANSFERT_ASK_TO_USER'),
          icon: 'medal-outline',
          handler: () => {
            this.currentAsk.TrasnfertAskTo("Target", Contact.Email)
          }
        })
      else
        buttons?.push({
          text: this.manager.Trad.Parse('STR_GET_STATEMENT_BACK_TO_TARGET'),
          icon: 'arrow-redo-outline',
          handler: () => {
            this.currentAsk.TrasnfertAskTo("Target", Contact.Email)
          }
        })
    } else if (this.CurrentAsk?.isOwner || this.currentAsk?.isOldOwner) {
      if (this.CurrentAsk?.isOwner)
        buttons?.push({
          text: this.manager.Trad.Parse('STR_TRANSFERT_ASK_TO_USER'),
          icon: 'medal-outline',
          handler: () => {
            this.currentAsk.TrasnfertAskTo("Owner", Contact.Email)
          }
        })
      else
        buttons?.push({
          text: this.manager.Trad.Parse('STR_GET_STATEMENT_BACK_TO_OWNER'),
          icon: 'arrow-redo-outline',
          handler: () => {
            this.currentAsk.TrasnfertAskTo("Owner", Contact.Email)
          }
        })
    }
    if (Contact?.Email != this.manager.Usr.EmailUser && this.manager.Usr.isLoged)
      buttons.push(
        contact != null
          ?
          {
            text: this.manager.Trad.Parse('STR_VIEW_CONTACT'),
            icon: 'eye',
            handler: () => {
              contact.navigateTo()
            }
          }
          :
          {
            text: this.manager.Trad.Parse('STR_ADD_TO_CONTACTS'),
            icon: 'person-add',
            handler: async () => {
              if (!this.manager.Ws.availableFeatures()) return;
              let answer = await this.manager.Ws.Send("UsersContacts", "create", {
                LastName: Contact.DisplayName,
                Email: Contact.Email
              }, true)
              LoggerService.info('Contact ajouté avec succès', answer)
              if (await this.manager.WaitForModuleData(5, "UsersContacts", answer.Data.Id))
                Contact.navigateToContact()
            }
          }
      )



    if (this.currentAsk?.OriginalTargetId != Contact.UserId && this.currentAsk?.OriginalOwnerId != Contact.UserId) {
      buttons.push({
        text: this.manager.Trad.Parse('STR_DELETE'),
        icon: 'trash',
        cssClass: 'dangerColor',
        handler: () => {
          this.confirmContact(Contact)
        }
      })
    }
    buttons.push({
      text: this.manager.Trad.Parse('STR_CLOSE'),
      icon: 'close',
      role: 'cancel'
    })


    const actionSheet = await this.actionSheetCtrl.create({ buttons: buttons })
    await actionSheet.present();
  }



  async openContacts() {
    if (!this.manager.Ws.availableFeatures()) {
      return
    }
    await this.manager.displayModal({
      component: ContactSelectorPage,
      componentProps: {
        contacts: this.Contacts,
        callBack: this.onSelect.bind(this)
      },
      cssClass: "transparent-modal rounded-modal",
      breakpoints: [0, 0.25, 0.5, 0.75, 1],
      initialBreakpoint: this.Contacts.length > 3 ? 1 : 0.5
    })
  }

  private onSelect(contact) {
    this.shareEmail = contact.Email
  }

}
